<template>
    <div v-if="this.$store.state.modal.content.title" class="d-flex align-items-center justify-content-between fsp20 text-black mb16 lh28">
        <div v-if="this.$store.state.resize.w <= 768" @click="close" class="pointer">
            <Icon name="arrow-left" />
        </div>
        <div :class="{ 'flex-grow-1 text-center pr24': this.$store.state.resize.w <= 768 }">{{ this.$store.state.modal.content.title }}</div>
        <div v-if="this.$store.state.resize.w > 768" @click="close" class="pointer">
            <Icon :name="'close'" />
        </div>
    </div>
    <div class="bg-white rounded w608" :class="{ 'p24': this.$store.state.resize.w > 768 }">
        <div v-if="type !== 'VA' || type === 'VA' && controlButtons" class="d-flex gap-2 flex-wrap mb32" :class="{ 'gap-3': this.$store.state.resize.w > 768 }">
            <Button
                @mouseover="iconHover = 'pencil'"
                @mouseleave="iconHover = false" 
                @click="rename" 
                class="primary-grey fsp14 h40 equal-width" 
                type='btn-outline-grey'
            >
                <Icon :name="'pencil'" class="c20 mr8 " :active="iconHover === 'pencil'" />
                {{ $t('components.service.modal.AssetDetails.1') }}
            </Button> 
            <Button
                @mouseover="iconHover = 'trash'"
                @mouseleave="iconHover = false"  
                @click="this.type === 'VA' ? this.deleteVA() : this.deleteKeyt()"
                :disabled="Number(this.content.curr.balance_copy) !== 0 && this.type !== 'VA'"
                class="fsp14 h40 equal-width" 
                type='btn-outline-red'
            >
                <Icon :name="'trash'" class="c20 mr8" :active="iconHover === 'trash'" />
                {{ $t('components.service.modal.AssetDetails.30') }}
            </Button> 
        </div>
        <div
            v-if="hasActiveBlocks"
            class="border-full rounded mb16 bg-light-blue"
            :class="{ 'p16': this.$store.state.resize.w > 768, 'p12': this.$store.state.resize.w <= 768 }"
        >
            <div class="d-flex align-items-center mb8">
                <Icon name="lock" class="c20 mr8 status-text-orange" />
                <span class="neue fw-medium text-black fsp16">{{ $t('components.service.modal.AssetDetails.40') }}</span>
            </div>
            <ul class="mb0 pl16 fsp14 primary-grey">
                <li v-for="(block, idx) in content.curr.blocks" :key="idx" class="lh20">
                    <span class="neue fw-medium text-black">{{ blockTypeLabel(block.type) }}</span>
                    <template v-if="block.type === 'amount' && block.amount">
                        <span>:</span>
                        <span class="ml4 neue fw-medium text-black">{{ block.amount }}</span>
                        <span class="ml4">{{ content.curr.curr }}</span>
                    </template>
                    <template v-if="block.info_for_user">
                        <span class="mx4">—</span>
                        <span>{{ block.info_for_user }}</span>
                    </template>
                </li>
            </ul>
        </div>
        <div v-if="this.type !== 'VA'" class="bg-light-grey border-full rounded" :class="{ 'p24': this.$store.state.resize.w > 768, 'p16': this.$store.state.resize.w <= 768, 'mb40': this.content.curr.custom === '1' }">
            <div class="d-flex flex-row align-items-center mh-52 col-8 w-100 border-b"
                :class="{ 'mb12 pb12': this.$store.state.resize.w <= 768, 'mb16 pb16': this.$store.state.resize.w > 768 }">
                <div v-if="content.curr.curr_logo || content.curr.image" class="item-i round-border contain c40 mr12" :class="{'mr12': this.isMobile, 'mr12': !this.isMobile}" :style="`background-image: url('${content.curr.curr_logo || content.curr.image}');`"></div>
                <div v-else class="mr12">
                    <Icon name="default-curr" size="c40" />
                </div> 
                <div class="d-flex flex-column flex-grow-1">
                    <div class="d-flex align-items-center justify-content-between flex-grow-1">
                        <div class="flex-grow-1">
                            <div class='neue-roman d-flex align-items-center flex-row'>
                                <span
                                v-if='content.curr.identifier'
                                :title='content.curr.identifier'
                                class="d-block text-black neue fw-medium text-truncate"
                                :class="{ 'lhp20 fsp14': this.$store.state.resize.w <= 768 }"
                                >
                                    {{ this.$store.state.resize.w <= 768 ? sbstring(content.curr.identifier) : content.curr.identifier }}
                                </span>
                                <span v-else :title='content.curr.code' class="text-black neue fw-medium text-truncate" :class="{ 'lhp20 fsp14': this.$store.state.resize.w <= 768 }">{{ content.curr.code }}</span>
                            </div>
                            <div class='primary-grey light col-10 text-truncate' :class="{'fsp12 lh16': this.isMobile, 'fsp14 lh20': !this.isMobile}" :title='content.name'>{{ content.curr.name }}</div>
                        </div>
                        <div>
                            <Button
                                @mouseover="iconHover = 'copy'"
                                @mouseleave="iconHover = false"  
                                v-if="this.$store.state.resize.w > 768" 
                                @click.stop="copy(content.curr.identifier || content.curr.code)" :name="''"
                                class="flex-grow-1 primary-grey w40 h40" type='btn-outline-grey stroke'
                            >
                                <Icon :name="'copy'" is_сolored class="pointer cli_2 c20" :active="iconHover !== 'copy'" />
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-between align-items-center" :class="{ 'mb16': this.$store.state.resize.w > 768 }">
                <div class="primary-grey" :class="this.$store.state.resize.w <= 768 ?'fsp14' : 'fsp16'">{{ $t('components.service.modal.AssetDetails.3') }}</div>
                <div v-if="content.curr.explorer_link && this.$store.state.resize.w > 768" class="d-flex align-items-center">
                    <a :href="content.curr.explorer_link" target="_blank" class="main-color w186 text-truncate main-color neue fw-medium text-decoration-underline">{{ content.curr.explorer_link }}</a>
                    <Icon :name="'external-link'" class="item-i ml4 c18" />
                </div>
                <div v-if="this.$store.state.resize.w <= 768" class="neue fw-medium text-black"><span v-html="this.sumMask(this.$lib.precRound(this, content.curr.balance_copy, content.curr.precision || 2))"></span> <span class="primary-grey">{{ content.curr.curr }}</span></div>
            </div>
            <div v-if="this.$store.state.resize.w > 768" class="fsp32 neue fw-medium text-black lhp40 mb6">{{ this.$lib.precRound(this, content.curr.balance_copy, content.curr.precision || 2) }} <span class="primary-grey fsp20">{{ content.curr.curr }}</span></div>
            <div v-if="content.curr.rate && content.curr.rate !== ''">
                <span v-html='this.sumMask(this.convertByRate())'></span>&nbsp;
                <span class="primary-grey">{{ this.$store.state.config.KEYTS_RATE_CURR_TEXT }}</span>
            </div>
            <div v-if="reservedAmount > 0" class="mt8 fsp14 primary-grey">
                {{ $t('components.service.modal.AssetDetails.41') }}:
                <span class="neue fw-medium status-text-orange">{{ formatReserved(reservedAmount, content.curr.precision || 2) }}</span>
                <span class="ml4">{{ content.curr.curr }}</span>
                <span class="ml8">·</span>
                <span class="ml8">{{ $t('components.service.modal.AssetDetails.42') }}:</span>
                <span class="ml4 neue fw-medium text-black">{{ formatReserved(availableBalance, content.curr.precision || 2) }}</span>
                <span class="ml4">{{ content.curr.curr }}</span>
            </div>
            <div v-if="this.$store.state.resize.w > 768" class="d-flex gap-3 mt16">
                <Button
                    :name="''" class="action-btn flex-grow-1" @click="paySelect('deposit')"
                    type='btn-warning' 
                    :class="{ 'flex-grow-1': this.$store.state.resize.w <= 768 }"
                >
                    <Icon :name="'deposit'" :size="'c18'" />
                    <span class="ml8 fsp14" :style="'white-space: nowrap;'">{{ this.$t('views.Home.27') }}</span>
                </Button> 
                <Button 
                    @mouseover="iconHover = 'withdraw'"
                    @mouseleave="iconHover = false"  
                    :name="''" class="action-btn flex-grow-1" @click="paySelect('withdraw')"
                    type="btn-outline-warning" 
                    :class="{ 'flex-grow-1': this.$store.state.resize.w <= 768 }"
                >
                    <Icon :name="'withdraw'" :size="'c18'" :hovered="iconHover === 'withdraw'" :active="false" />
                    <span class="ml8 fsp14 neue fw-medium" :style="'white-space: nowrap;'">{{ this.$t('views.Home.26') }}</span>
                </Button> 
            </div>
        </div>
        <CustomSelectButton
            v-if="this.content.curr.custom === '1' || this.type === 'VA'"
            class="w-100 sections"
            v-model:modelValue="this.section"
            :small="true"
            :options="[
                { label: this.$t('components.service.modal.AssetDetails.7'), value: 0 }, 
                { label: this.$t('components.service.modal.AssetDetails.8'), value: 1 }, 
                { label: this.$t('components.service.modal.AssetDetails.9'), value: 2 }, 
                { label: this.$t('components.service.modal.AssetDetails.10'), value: 3 }, 
                { label: this.$t('components.service.modal.AssetDetails.11'), value: 4 }
            ]" 
        />
        <div v-if="this.content.curr.custom === '1' || this.type === 'VA'">
            <div v-if="this.section === 0" class="mt24 text-black">
                <div class="d-flex align-items-center gap-2 mb16" :class="{ 'fsp16': this.$store.state.resize.w < 768, 'fsp20': this.$store.state.resize.w > 768 }">
                    {{ $t('components.service.modal.AssetDetails.4') }}
                </div>
                <div class="d-flex flex-column g-16" :class="{ 'fsp12': this.$store.state.resize.w < 768 }">
                    <div v-if="content.curr.owner_keyt" class="d-flex align-items-center justify-content-between lh-base">
                        <div class="primary-grey neue-roman text-nowrap">{{ $t('components.service.modal.AssetDetails.18') }}</div>
                        <div class="d-flex align-items-center min-w-0">
                            <div v-if='content.curr.owner_keyt_alias' class="ml16 text-truncate min-w-0">{{ sbstring(content.curr.owner_keyt_alias) }}</div>
                            <span v-else class="ml16 text-truncate">{{ content.curr.owner_keyt }}</span>
                            <Icon :name="'copy'" class="ml4 c20 pointer" :class="{ 'c16': this.$store.state.resize.w <= 768 }" @click.stop="copy(content.curr.owner_keyt_alias ? content.curr.owner_keyt_alias : content.curr.owner_keyt)" />
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="primary-grey neue-roman text-nowrap ">{{ $t('components.service.modal.AssetDetails.19') }}</div>
                        <div class="ml16 text-truncate min-w-0">{{ this.type === 'VA' ? content.curr.name : content.curr.curr_name }}</div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="primary-grey neue-roman text-nowrap">{{ $t('components.service.modal.AssetDetails.5') }}</div>
                        <div class="ml16 text-truncate min-w-0">{{ content.curr.currency }}</div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="primary-grey neue-roman text-nowrap">{{ $t('components.service.modal.AssetDetails.6') }}</div>
                        <div class="ml16 min-w-0 text-truncate">{{ content.curr.accept == '1' || content.curr.accept === true ? this.$t('views.ShowInfoVA.24') : this.$t('views.ShowInfoVA.28') }}</div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="primary-grey neue-roman text-nowrap">{{ $t('components.service.modal.AssetDetails.20') }}</div>
                        <div class="d-flex align-items-center min-w-0">
                            <div class="text-end ml16 text-truncate">{{ content.curr.owner_name }}</div>
                            <router-link :to="`/corr_info?uid=${content.curr.uid}`" target="_blank">
                                <Icon 
                                    name="external-link" 
                                    :active="false" 
                                    class="ml4 c20 pointer" 
                                    :class="{ 'c16': this.$store.state.resize.w <= 768 }" 
                                />
                            </router-link>
                        </div>
                    </div>
                    <div v-if="content.curr.blockchain_type" class="d-flex align-items-center justify-content-between">
                        <div class="primary-grey neue-roman text-nowrap">{{ $t('components.service.modal.AssetDetails.34') }}</div>
                        <div class="text-end ml16 min-w-0 text-truncate">{{ content.curr.blockchain_type }}</div>
                    </div>
                </div>
            </div>
            <div v-else-if="this.section === 1" class="mt24 text-black">
                <div class="d-flex align-items-center gap-2 neue mb16" :class="{ 'fsp16': this.$store.state.resize.w < 768, 'fsp20': this.$store.state.resize.w > 768 }">
                    {{ $t('components.service.modal.AssetDetails.12') }}
                </div>
                <div class="d-flex flex-column g-16" :class="{ 'fsp12': this.$store.state.resize.w < 768 }">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.35') }}</div>
                        <div>{{ content.curr.fiat == '1' ? $t('components.service.modal.AssetDetails.36') : $t('components.service.modal.AssetDetails.37') }}</div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.13') }}</div>
                        <div>{{ content.curr.precision }}</div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.14') }}</div>
                        <div>{{ content.curr.current_emission }}</div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.15') }}</div>
                        <div>{{ content.curr.max_emission }}</div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.16') }}</div>
                        <div v-if="this.content.curr.bind_curr">
                            {{ this.content.curr.bind_custom_count }} 
                            {{ this.content.curr.currency }} = 
                            {{ this.content.curr.bind_count }}
                            {{ this.$store.getters.get_curr(this.content.curr.bind_curr).small_name }}
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.17') }}</div>
                        <span v-if="this.content.curr.cover_percent !== '0.00'">
                            {{ this.content.curr.cover_percent }}%
                        </span>
                    </div>
                </div>
            </div>
            <div v-else-if="this.section === 2" class="mt24 text-black">
                <div class="d-flex align-items-center gap-2 neue mb16" :class="{ 'fsp16': this.$store.state.resize.w < 768, 'fsp20': this.$store.state.resize.w > 768 }">
                    {{ $t('components.service.modal.AssetDetails.21') }}
                </div>
                <div class="d-flex flex-column g-16" :class="{ 'fsp12': this.$store.state.resize.w < 768 }">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.22') }}</div>
                        <span>
                            <Icon v-if="this.content.curr.access_atm_buy == 1" name="check-green" class="c20" />
                            <Icon v-else name="circle-x" class="c20" />
                        </span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.23') }}</div>
                        <span>
                            <Icon v-if="this.content.curr.access_atm_sell == 1" name="check-green" class="c20" />
                            <Icon v-else name="circle-x" class="c20" />
                        </span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.24') }}</div>
                        <span>
                            <Icon v-if="this.content.curr.access_offer == 1" name="check-green" class="c20" />
                            <Icon v-else name="circle-x" class="c20" />
                        </span>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="primary-grey neue-roman">{{ $t('components.service.modal.AssetDetails.25') }}</div>
                        <span>
                            <Icon v-if="this.content.curr.access_p2p == 1" name="check-green" class="c20" />
                            <Icon v-else name="circle-x" class="c20" />
                        </span>
                    </div>
                </div>
            </div>
            <div v-else-if="this.section === 3" class="mt24 text-black">
                <div class="d-flex align-items-center gap-2 neue mb16" :class="{ 'fsp16': this.$store.state.resize.w < 768, 'fsp20': this.$store.state.resize.w > 768 }">
                    {{ $t('components.service.modal.AssetDetails.26') }}
                </div>
                <div class="d-flex flex-column g-16" :class="{ 'fsp12': this.$store.state.resize.w < 768 }">
                    <div>
                        <div class="primary-grey mbp-8 neue-roman">{{ $t('components.service.modal.AssetDetails.27') }}</div>
                        <div class="text-black neue-roman">{{ this.content.curr.category }}</div>
                    </div>
                    <div>
                        <div class="primary-grey mbp-8 neue-roman">{{ $t('components.service.modal.AssetDetails.28') }}</div>
                        <div class="text-black neue-roman">{{ this.content.curr.mission }}</div>
                    </div>
                </div>
            </div>
            <div v-else-if="this.section === 4" class="mt24 text-black">
                <div class="d-flex align-items-center gap-2 neue mb16" :class="{ 'fsp16': this.$store.state.resize.w < 768, 'fsp20': this.$store.state.resize.w > 768 }">
                    {{ $t('components.service.modal.AssetDetails.29') }}
                </div>
                <div class="d-flex flex-column g-16" :class="{ 'fsp12': this.$store.state.resize.w < 768 }">
                    <div v-for="(item, index) in this.content.links" :key="index">
                        <div v-if="item.icon && item.text" class="d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center gap-2">
                                <Icon :name="item.icon" class="c20" />
                                <span class="primary-grey neue-roman text-nowrap">{{ item.text }}</span>
                            </div>
                            <div class="d-grid min-w-0">
                                <span class="ml16 text-truncate pointer" @click="copy(item.value)">{{ item.value }}</span>
                            </div>
                        </div>
                        <div v-else-if="!item.icon && !item.text">
                            <div class="primary-grey neue-roman mb8" :class="{ 'fsp12 lh16': this.$store.state.resize.w <= 768 }">{{ this.$t('views.ShowInfoVA.30') }}</div> 
                            <div class="neue-roman" :class="{ 'fsp12 lh16': this.$store.state.resize.w <= 768 }">{{ item.value }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="this.type === 'VA' && controlButtons" class="d-flex" :class="{ 'position-fixed bottom-0 left-0 end-0 bg-white py16 px24 border-t w-100': this.isMobile, 'mt40': !this.isMobile }">
            <Button @click="addMoreEmission" type="btn-warning" class="equal-width h40 mr16" :class="{ 'h48': this.isMobile }">
                <Icon name="coins" size="c20" class="mr8" />
                {{ $t('components.service.modal.AssetDetails.38') }}
            </Button>
            <Button 
                @click="burnTokens"
                @mouseover="iconHover = 'burn'" 
                @mouseleave="iconHover = false" 
                type="btn-outline-warning" 
                class="equal-width h40"
                :class="{ 'h48': this.isMobile }"
            >
                <Icon name="money_burn" size="c20" class="mr8" :active="iconHover === 'burn'" />
                {{ $t('components.service.modal.AssetDetails.39') }}
            </Button>
        </div>
    </div>
</template>

<script>
import Button from '@/components/service/Button';
import Input from '@/components/service/Input';
import Icon from '@/components/icons/Icon'
import CustomSelectButton from "@/components/service/CustomSelectButton.vue";

export default {
    components: {
        Button,
        Input,
        CustomSelectButton,
        Icon
    },
    props: {
        close: [Function],
    },
    data () {
        return {
            title: this.$store.state.modal.content.title,
            content: this.$store.state.modal.content.body,
            section: 0,
            iconHover: false,
            controlButtons: this.$store.state.modal.content.controlButtons,
            type: this.$store.state.modal.content.type,
            callback: this.$store.state.modal.content.callback,
        }
    },
    computed: {
        isMobile () {
            return this.$store.state.resize.w <= 768;
        },
        hasActiveBlocks() {
            const blocks = this.content?.curr?.blocks;
            return Array.isArray(blocks) && blocks.length > 0;
        },
        reservedAmount() {
            const blocks = this.content?.curr?.blocks || [];
            return blocks
                .filter(b => b.type === 'amount' && b.amount)
                .reduce((acc, b) => acc + Number(b.amount), 0);
        },
        availableBalance() {
            const balance = Number(this.content?.curr?.balance_copy || 0);
            return Math.max(0, balance - this.reservedAmount);
        },
    },
    methods: {
        copy(text) {
            this.$lib.copyTextS(text, this.$store)
        },
        blockTypeLabel(type) {
            const keyMap = { in: 55, out: 56, full: 57, amount: 58 };
            return keyMap[type] ? this.$t(`views.Keyts.List.${keyMap[type]}`) : type;
        },
        formatReserved(value, precision) {
            return this.$lib.precRound(this, String(value), precision || 2);
        },
        paySelect(modalName) {
            if(modalName === 'deposit') {
                this.$store.commit('MODAL', {
                    action: true,
                    type: 'PaySelect',
                    content: {
                        title: this.$store.state.resize.w < 768 ? this.$t('views.Keyts.List.28') : this.$t('views.Keyts.List.46'),
                        action: 'payIn',
                        keyt: this.content,
                        width: 608,
                    }
                })
            } else if(modalName === 'withdraw') {
                this.$store.commit('MODAL', {
                    action: true,
                    type: 'PaySelect',
                    content: {
                        title: this.$store.state.resize.w < 768 ? this.$t('views.Keyts.List.29') : this.$t('views.Keyts.List.47'),
                        action: 'payOut',
                        keyt: this.content,
                        width: 608,
                    }
                })
            }
        },
        deleteKeyt() {
            this.$store.commit('MODAL', {
                action: true,
                type: 'DeleteKeyt',
                content: {
                    title: this.$t('components.service.modal.AssetDetails.31'),
                    body: this.content,
                    width: 608,
                },
            });
        },
        rename() {
            if(this.type === 'VA') {
                this.$router.push({ path: '/va/new', query: { curr: this.content.curr.curr_code } });
                this.$store.commit('MODAL', {
                    action: false,
                    type: false,
                    content: false,
                });
                this.$store.commit('DARK_WRAPPER', false);
                return;
            }
            this.$store.commit('MODAL', {
                action: true,
                type: 'k_rename',
                content: {
                    title: this.$t('components.service.modal.AssetDetails.32'),
                    body: this.content,
                    width: 608,
                },
            });
        },
        deleteVA() {
            this.$store.commit('MODAL', {
                action: true,
                type: 'confirm',
                content: {
                    title: this.$t('components.service.modal.Confirm.5'),
                    text: this.$t('views.VA.ListVa.36'),
                    callback: () => {
                        this.stopWindowOpen = true;
                        this.axios.post('DeleteCurrency', {loader: 'mini', data: {code: this.content.curr.code || this.content.curr.curr_code}}).then(res => {this.callback()});
                    }
                },
            });
        },
        burnTokens() {
            this.$store.commit('MODAL', {
                action: true,
                type: 'BurnCustomCurr',
                content: {
                    curr: this.content.curr,
                    currs: this.content.currs,
                    title: this.$t('components.service.modal.BurnEmission.1'),
                    width: 672
                },
            }
            );
        },
        addMoreEmission() {
            this.$store.commit('MODAL', {
                action: true,
                type: 'emission',
                content: {
                    curr: this.content.curr,
                    currs: this.content.currs,
                    title: this.$t('components.service.modal.Emission.1'),
                    width: 672
                },
            }
            );
        },
        sbstring(str) {
            if (this.$store.state.resize.w < 1024 && this.$store.state.resize.w > 768 && str.length > 7) {
                return this.$lib.getTokenString(str, 4);
            } else if(this.$store.state.resize.w <= 768) {
                return this.$lib.getTokenString(str, 12);
            } else if (this.$store.state.resize.w < 1200 && str.length > 12) {
                return this.$lib.getTokenString(str, 8);
            } else if (str.length > 30) {
                return this.$lib.getTokenString(str, 8);
            } 
            return this.$lib.getTokenString(str, 6);
        },
        sizedName(str) {
            if (!str) {
                return "";
            } else if (this.$store.state.resize.w < 720 && str.length > 20) {
                return str.substring(0, 20) + "...";;
            } else if (this.$store.state.resize.w < 1200 && str.length > 20) {
                return this.$lib.getTokenString(str, 8);
            } else if (str.length > 34) {
                return str.substring(0, 35) + "...";
            }
            return str;
        },
        sumMask(sum, isSameSize) {
            if (!sum) {
                return;
            }
            let classList = `${this.isMobile ? 'fsp20' : ''} text-black`
            if(isSameSize) {
                classList = 'fsp16'
            }
            let arr = sum.split('.');
            if (arr[1]) {
                return `<span  class='${classList}'>${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}</span><span class='neue fw-medium fsp12 primary-grey'>.${arr[1]}</span>`
            } else {
                return `<span  class='${classList}'>${arr[0].replace(/(\d)(?=(\d\d\d)+\b)/ig, '$1  ')}</span>`
            }
        },
        convertByRate() {
            return this.$lib.precRound(this, this.$lib.ev(this, `${this.content.curr.balance_copy} * ${this.content.curr.rate}`), '2');
        }
    },
}
</script>
<style lang="scss" scoped>
.w186 {
    width: 186px;
}

.g-16 {
    gap: 16px;
}
.min-w-0 {
    min-width: 0;
}
</style>
